import { render, staticRenderFns } from "./CompanyProgramsList.vue?vue&type=template&id=5454fb34&scoped=true"
import script from "./CompanyProgramsList.vue?vue&type=script&lang=js"
export * from "./CompanyProgramsList.vue?vue&type=script&lang=js"
import style0 from "./CompanyProgramsList.vue?vue&type=style&index=0&id=5454fb34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5454fb34",
  null
  
)

export default component.exports